import { render, staticRenderFns } from "./bidOpeningView.vue?vue&type=template&id=5872d598&scoped=true&"
import script from "./bidOpeningView.vue?vue&type=script&lang=js&"
export * from "./bidOpeningView.vue?vue&type=script&lang=js&"
import style0 from "./bidOpeningView.vue?vue&type=style&index=0&id=5872d598&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5872d598",
  null
  
)

export default component.exports